import { ReactNode, CSSProperties } from 'react'
import { motion } from 'framer-motion'
import { element, string } from 'prop-types'

interface Props {
  children: ReactNode | ReactNode[]
  className?: string
  style?: CSSProperties
}

/**
 * The animated motion div wrapper.
 * @param props React props
 * @param {ReactNode} props.children ReactNode elements nested inside the container.
 * @param {string} props.className The class name on the motion.div.
 * @returns
 */
export const MotionDivContainer = ({ children, className = '', style = {}, ...rest }: Props) => {
  return (
    <motion.div
      {...rest}
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.15 } }}
      exit={{ opacity: 0, transition: { duration: 0.15 } }}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        ...style,
      }}
    >
      {children}
    </motion.div>
  )
}

MotionDivContainer.propTypes = {
  children: element.isRequired,
  className: string,
}
